import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import { Modal } from 'react-bootstrap';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';
import { Tools } from '../utils/tools';
import FinanciadoInactive from '../assets/images/financiado_inactive.png';
import FinanciadoActive from '../assets/images/financiado_active.png';
import NoFinanciadoInactive from '../assets/images/nofinanciado_inactive.png';
import NoFinanciadoActive from '../assets/images/nofinanciado_active.png';
import DownloadIcon from '../assets/images/download.png';
import ApiService from '../services/Api';
import { Global } from '../services/Global';
import { APIS } from '../services/Config';

const mapStateToProps = (props) => { return {glo: props.general, pro: props.process} }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class FinancingPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            financiamientoCheck: false,
            isChecked: false,
            show_dc: false,
            accept_dc: true,
            costo: '0.00',
            pacademico: ''
        }
    }

    componentDidMount() {
        let _root = this;

        if(!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {
            for(let item of document.querySelectorAll('.btn-fin')) {
                if(_root.props.pro.financiamientoTipo == item.textContent) {
                    _root.setState({
                        financiamientoCheck: (_root.props.pro.financiamientoTipo == 'No Financiado') ? false : true
                    }, () => {
                        item.classList.add('active');
                    });
                }
            }

            if(_root.props.pro.financiamientoAceptacionCondiciones == true  && (_root.props.pro.financiamientoTipo == 'Financiado') ) {
                _root.setState({
                    accept_dc: true
                }, () => {
                    document.getElementById('declaracion_j').checked = true;
                });
            }

            _root.setState({
                program_selected: JSON.parse( Tools.decryptrData(localStorage.getItem('app_sp')) ),
                costo: _root.props.glo.costo,
                pacademico: _root.props.glo.pacademico
            }, () => {
            });
        }
    }

    onChange = (e) => {
        // e.preventDefault();
        let _target = e.target;
        let _root = this;

        if(_target.name == 'declaracion_j') {
            _root.setState({
                isChecked: true,
                show_dc: true
            }, () => {
                if(_root.props.pro.financiamientoTipo == 'Financiado') {
                    _root.props.pro.financiamientoAceptacionCondiciones = _target.checked;
                    document.getElementById('declaracion_j').checked = _target.checked;
                }
            });
        }
    }

    onClickFinancing = (e) => {
        e.preventDefault();
        let _target = e.currentTarget;
        let _root = this;

        // financiamientoTipo
        for(let item of document.querySelectorAll('.btn-fin')) {
            item.classList.remove('active');
        }

        if(_target.textContent == 'No Financiado') {
            _root.setState({
                isChecked: false
            }, () => {
                _root.props.pro.financiamientoAceptacionCondiciones = false;
            });
        }

        _root.setState({
            financiamientoCheck: (_target.textContent == 'No Financiado') ? false : true
        }, () => {
            _root.props.pro.financiamientoTipo = _target.textContent;
            _target.classList.add('active');
        });

    }

    hideDC = (e) => {
        // e.preventDefault();
        let _root = this;

        if(_root.state.accept_dc) {
            _root.setState({
                show_dc: false
            });
        }
        else {
            _root.setState({
                show_dc: false,
                isChecked: false
            });
        }
    } 

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;

        if(_root.props.pro.financiamientoTipo == 'Financiado') {
            if(_root.props.pro.financiamientoAceptacionCondiciones) {
                Tools.showPreloader();
                _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/financiamiento'));
                _root.props.process(_root.props.pro);
                _root.props.general(_root.props.glo);
                ApiService.postData(`${APIS.submission}`, _root.props.pro)
                .then(res => {
                    Tools.hidePreloader();
                    if(_root.props.pro.financiamientoTipo != '') {
                        _root.props.navigate('/informacion-academica');
                    }
                })
                .catch(err => { 
                    Tools.hidePreloader();
                    console.log(err); 
                });
            }
            else {
                Tools.showToaster('error', '', 'Tienes que aceptar la declaración.');
            }
        }
        else {
            Tools.showPreloader();
            _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/financiamiento'));
            _root.props.process(_root.props.pro);
            _root.props.general(_root.props.glo);
            ApiService.postData(`${APIS.submission}`, _root.props.pro)
            .then(res => {
                Tools.hidePreloader();
                if(_root.props.pro.financiamientoTipo != '') {
                    _root.props.navigate('/informacion-academica');
                }
            })
            .catch(err => { 
                Tools.hidePreloader();
                console.log(err); 
            });
        }
    }

    onClickDownload = (e) => {
        e.preventDefault();
        let _root = this;

        ApiService.getDataFile(`${APIS.ddjjGenera}${_root.props.pro.idSubmission}`)
        .then((rescp) => {
            Tools.hidePreloader();
            const blob = new Blob([rescp.data], { type: 'application/pdf' });
            const objectUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = `declaracion-jurada.pdf`;

            link.dispatchEvent(
                new MouseEvent('click', { 
                    bubbles: true, 
                    cancelable: true, 
                    view: window 
                })
            );
            setTimeout(() => {
                window.URL.revokeObjectURL(objectUrl);
                link.remove();
            }, 100);
        })
        .catch((err) => {
            Tools.hidePreloader();
        });
    }
    
    render() {
        const {
            program_selected,
            show_dc,
            isChecked,
            accept_dc,
            financiamientoCheck,
            costo,
            pacademico
        } = this.state;

        const {
            navigate
        } = this.props;

        return (
            <>
            <div className="container">
                <div className="row app-layout-main">
                    <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                        { (program_selected !== null) ? <DashboardMenuComponent navigate={navigate} form={program_selected.form} /> : <></> }
                    </div>
                    <div className="col-md-9 right-side-dashboard">
                        <TopProcessComponent porcent="20" />
                        <div className="row content-dashboard">
                            <div className="col-sm-12">
                                <div className="row pt-3 pb-3">
                                    <div className="col-sm-12 col-md-6"><TopComponent direction="back" label="Paso Previo" path="/datos-conyuge" /></div>
                                </div>
                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-6">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                                { (program_selected !== null) ? <h2><strong>Financiamiento de { program_selected.label }</strong></h2> : <></> }
                                            </div>
                                            <div className="col-sm-12"></div>
                                            <div className="col-sm-12">
                                                <p><small><strong>La Maestría puede ser financiada o pagada en su totalidad ¡Elige la opción que prefieras!</strong></small></p>
                                                <p className="text-gray"><small>El financiamiento se realiza directamente con la Escuela de Postgrado de la UTP en cuotas mensuales, sin intereses y sin intermediación bancaria.</small></p>
                                            </div>
                                            {
                                                (financiamientoCheck)
                                                ?
                                                <>
                                                    <div className="col-sm-12">
                                                        <div className="form-check pb-2">
                                                            <input className="form-check-input" type="checkbox" value="" id="declaracion_j" name="declaracion_j" onChange={this.onChange} checked={isChecked} />
                                                            <label className="form-check-label" for="declaracion_j">Declaración Condiciones de Financiamiento de Estudios <span className="text-danger">*</span></label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12">
                                                        <small className="text-danger">*Obligatorio</small>
                                                    </div>
                                                </>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <div className="row">
                                            <div className="col-sm-12 mt-4 mb-4">
                                                <button type="button" className={'btn btn-primary btn-style-5 btn-fin'} onClick={this.onClickFinancing}>
                                                    <img className="icon" src={FinanciadoInactive} /> 
                                                    <img className="icon-active" src={FinanciadoActive} />
                                                    Financiado</button>
                                            </div>
                                            <div className="col-sm-12 mb-4">
                                                <button type="button" className={'btn btn-primary btn-style-5 btn-fin'} onClick={this.onClickFinancing}>
                                                    <img className="icon" src={NoFinanciadoInactive} /> 
                                                    <img className="icon-active" src={NoFinanciadoActive} /> 
                                                    No Financiado</button>
                                            </div>
                                            <div className="col-sm-12 mt-3">
                                                <button className={(accept_dc) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4 disable'} onClick={this.onClickNext}>Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal size="lg" show={show_dc} onHide={this.hideDC}>
                <Modal.Header closeButton>
                </Modal.Header>

                <Modal.Body>
                    <h5 className="text-center pb-5"><strong>Condiciones de Financiamiento de Estudios</strong></h5>
                     <p><small>Yo, { this.props.pro.nombres +" "+this.props.pro.apellidoPaterno+" "+this.props.pro.apellidoMaterno} debidamente identificado con <strong>DNI/CE/PASAPORTE {this.props.pro.nroDocumento}</strong>, (en adelante, EL ESTUDIANTE), acepto y declaro conocer las siguientes condiciones del financiamiento de estudios otorgado por la UNIVERSIDAD TECNOLÓGICA DEL PERÚ (en adelante, UTP):</small></p>
                    <p><small><strong>PRIMERO</strong> La UTP es una Institución dedicada a la enseñanza y capacitación profesional.</small></p>
                    <p><small><strong>SEGUNDO</strong> La UTP concede a EL ESTUDIANTE un financiamiento hasta por la suma de S/. <strong>______</strong> para que éste pueda matricularse en el programa académico <strong>_________</strong></small></p>
                    <p><small><strong>TERCERO</strong> El financiamiento será pagado por EL ESTUDIANTE mediante cuotas mensuales, de acuerdo con el número, frecuencia y monto de las mismas, según lo establecido por la UTP.</small></p>
                    <p><small><strong>CUARTO</strong> En caso que EL ESTUDIANTE incumpliese con pagar las cuotas respectivas en su oportunidad, la UTP cobrará los gastos de mora correspondiente (0.017% del valor de la cuota mensual aplicado diariamente).</small></p>
                    <p><small><strong>QUINTO</strong> Sujeto al cumplimiento de las condiciones que la UTP señale, podrá refinanciarse la deuda no pagada oportunamente por EL ESTUDIANTE. En dicho caso, el refinanciamiento acordado y previamente aprobado por UTP seguirá rigiéndose por las mismas condiciones establecidas en el presente documento y contando con las garantías que se constituyen en su respaldo. Se precisa, sin embargo, que cualquier refinanciamiento se concederá sólo si la UTP lo estima conveniente, no asumiendo ésta ninguna obligación de hacerlo.</small></p>
                </Modal.Body>

                <Modal.Footer>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-check pb-2">
                                    <label className="form-check-label" for="declaracion_accept">Descarga y firma tu Declaración Jurada y más adelante; cuando llegues a la sección 4 (Documentación), súbela.</label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <a className="btn btn-primary btn-style-7" href={'#'} onClick={this.onClickDownload}>Descargar.<img className="icon" src={DownloadIcon} /></a>
                            </div>
                            <div className="col-sm-12 col-md-6 text-right ml-3">
                                <button className={ (accept_dc) ? 'btn btn-primary btn-style-1 w-50' : 'btn btn-primary btn-style-1 w-50 disable'} onClick={this.onClickNext}>Continuar</button>
                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FinancingPage);